import React from 'react'
import { OrderedListOutlined } from '@ant-design/icons'
import { DataTable } from './DataTable'
import { YhBox } from "@src/components/YhBox";

export const DataBox = () => {
    return (
        <YhBox title={<OrderedListOutlined />} >
            <DataTable />
        </YhBox>
    )
}